module.exports = __webpack_public_path__ + "media/customizations/lakenona/logo-fa8eb94290fdf9d30e91ababb4b88d43.png";